import { render, staticRenderFns } from "./CandidateDetailedScores.vue?vue&type=template&id=72fa7b1f&"
import script from "./CandidateDetailedScores.vue?vue&type=script&lang=js&"
export * from "./CandidateDetailedScores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports